export default [
  {
    name: "base",
    data: {},
    items: [
      {
        name: "googleHomeLedMaskTexture",
        source: "/assets/googleHomeLedMask.png",
        type: "texture",
      },
      {
        name: "googleHomeLedsModel",
        source: "/assets/googleHomeLedsModel.glb",
        type: "model",
      },

      {
        name: "loupedeckButtonsModel",
        source: "/assets/loupedeckButtonsModel.glb",
        type: "model",
      },

      {
        name: "topChairModel",
        source: "/assets/topChairModel.glb",
        type: "model",
      },
      {
        name: "cakeModel",
        source: "/assets/fo3_birthday_cake/scene.glb",
        type: "model",
      },
      {
        name: "hatModel",
        source: "/assets/party_hat_v2/scene.glb",
        type: "model",
      },
      {
        name: "FrameModel",
        source: "/assets/pidgey_picture_frame/scene.glb",
        type: "model",
      },
      {
        name: "streamerModel",
        source: "/assets/teal_balloon_times_five/scene.glb",
        type: "model",
      },

      {
        name: "coffeeSteamModel",
        source: "/assets/coffeeSteamModel.glb",
        type: "model",
      },

      {
        name: "elgatoLightModel",
        source: "/assets/elgatoLightModel.glb",
        type: "model",
      },

      {
        name: "envatomarket",
        source: "/assets/envatomarket.png",
        type: "texture",
      },

      {
        name: "pcScreenModel",
        source: "/assets/pcScreenModel.glb",
        type: "model",
      },
      {
        name: "tvScreenModel",
        source: "/assets/tvScreenModel.glb",
        type: "model",
      },
      {
        name: "FramePicture",
        source: "/assets/FramePicture.glb",
        type: "model",
      },

      {
        name: "macScreenModel",
        source: "/assets/macScreenModel.glb",
        type: "model",
      },

      { name: "bakedTexture", source: "/assets/baked.jpg", type: "texture" },
      {
        name: "hatTexture",
        source: "/assets/party_hat_v2/material_metallicRoughness.png",
        type: "texture",
      },
      {
        name: "balloonTexture",
        source:
          "/assets/teal_balloon_times_five/textures/defaultMat_metallicRoughness.png",
        type: "texture",
      },
      {
        name: "cakeTexture",
        source: "/assets/fo3_birthday_cake/textures/Material_baseColor.png",
        type: "texture",
      },
      {
        name: "frameTexture",
        source: "/assets/pidgey_picture_frame/lambert1_baseColor.png",
        type: "texture",
      },

      { name: "roomModel", source: "/assets/roomModel.glb" },
    ],
  },
];
